import React from 'react';
import styled from 'styled-components';
import { asStyledComponent } from '@cld/component-enhancer';
import Footer from '@cld/footer';
import { media } from '@cld/style-utils';

const Content = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;

  @media ${media.phone()} {
    && {
      max-width: 100vw;
      height: calc(100vh - 45px);
      max-height: calc(100vh - 45px);
    }
  }
`;

const Navigation = styled.div`
  min-width: 0;

  @media ${media.phone()} {
    width: 100%;
  }
`;

const Spacer = styled.div`
  flex: 1 1;
`;

const Root = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: 100vh;
  min-height: 100vh;
  overflow-x: hidden;
  & > * {
    max-height: 100%;
    min-height: 0;
    overflow: auto;
  }

  @media ${media.phone()} {
    flex-direction: column;
    height: auto;
  }
`;

export const MainLayoutBase = ({ navigation, content, contentRef, ...rest }) => {
  return (
    <Root {...rest}>
      <Navigation> {navigation}</Navigation>
      <Content ref={contentRef}>
        {content}
        <Spacer />
        <Footer />
      </Content>
    </Root>
  );
};

export const MainLayout = asStyledComponent(MainLayoutBase);
